// extracted by mini-css-extract-plugin
export default {"recordsModal":"styles_recordsModal__ng1DY"};